import {
	SET_PAGE_VIEWER_SOURCE,
	SET_PAGE_VIEWER_VISIBLE
} from './integration-mutation-types';
import buildRoute from '@/composables/build-route';
import store from '@/store/index.js';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'integration',
	namespaced: true,
	state: {
		pageViewerSource: null,
		pageViewerVisible: false,
		accessWebUrlConfigName: 'app/VUE_APP_ACCESSWEB_URL',
		accessWebPageViewerUrl: '/System/PageViewer'
	},
	mutations: {
		[SET_PAGE_VIEWER_SOURCE](state, pageViewerSource) {
			state.pageViewerSource = pageViewerSource;
		},
		[SET_PAGE_VIEWER_VISIBLE](state, pageViewerVisible) {
			state.pageViewerVisible = pageViewerVisible;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		setPageViewerSourceAction({ commit, getters }, { linkType, args }) {
			let url = `${getters.accessWebUrl}${getters.accessWebPageViewerUrl}`;
			const json = '' || JSON.stringify(args);

			url = buildRoute(url, {
				query: { alertLinkType: linkType, args: json }
			});

			commit(SET_PAGE_VIEWER_SOURCE, url);
		},
		setPageViewerVisibleAction({ commit }, pageViewerVisible) {
			commit(SET_PAGE_VIEWER_VISIBLE, pageViewerVisible);

			if (!pageViewerVisible) {
				commit(SET_PAGE_VIEWER_SOURCE, null);
			}
		}
	},
	getters: {
		pageViewerSource: state => state.pageViewerSource,
		pageViewerVisible: state => state.pageViewerVisible,
		accessWebUrl: state => {
			return store.getters[state.accessWebUrlConfigName];
		},
		accessWebPageViewerUrl: state => state.accessWebPageViewerUrl
	}
};
